export const facebook = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <circle cx="12" cy="12.9879" r="12" />
    <path
      d="M12.6667 14.0379H14.3333L15 11.2379H12.6667V9.83791C12.6667 9.11691 12.6667 8.43792 14 8.43792H15V6.08592C14.7827 6.05582 13.962 5.98792 13.0953 5.98792C11.2853 5.98792 10 7.14781 10 9.27791V11.2379H8V14.0379H10V19.9879H12.6667V14.0379Z"
      fill="#C9E6E4"
    />
  </svg>
);

export const instagram = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12.9879" r="12" />
    <path
      d="M14.6787 6.32092H9.29865C8.24742 6.32216 7.23961 6.74035 6.49634 7.48375C5.75307 8.22714 5.33504 9.23502 5.33398 10.2863L5.33398 15.6663C5.33522 16.7175 5.75341 17.7253 6.49681 18.4686C7.2402 19.2118 8.24809 19.6299 9.29932 19.6309H14.6793C15.7305 19.6297 16.7384 19.2115 17.4816 18.4681C18.2249 17.7247 18.6429 16.7168 18.644 15.6656V10.2856C18.6428 9.23436 18.2246 8.22655 17.4812 7.48328C16.7378 6.74 15.7299 6.32198 14.6787 6.32092ZM17.3053 15.6656C17.3053 16.0105 17.2374 16.3521 17.1054 16.6708C16.9734 16.9895 16.7799 17.279 16.536 17.5229C16.2921 17.7668 16.0025 17.9603 15.6838 18.0923C15.3652 18.2243 15.0236 18.2923 14.6787 18.2923H9.29865C8.60213 18.2921 7.9342 18.0153 7.44175 17.5227C6.9493 17.0301 6.67265 16.3621 6.67265 15.6656V10.2856C6.67283 9.58907 6.94964 8.92114 7.44222 8.42869C7.9348 7.93624 8.6028 7.65959 9.29932 7.65959H14.6793C15.3758 7.65977 16.0438 7.93658 16.5362 8.42916C17.0287 8.92173 17.3053 9.58974 17.3053 10.2863V15.6656Z"
      fill="#C9E6E4"
    />
    <path
      d="M11.9882 9.53381C11.0758 9.53522 10.2012 9.89834 9.55614 10.5436C8.91105 11.1888 8.54811 12.0634 8.54688 12.9758C8.54793 13.8884 8.91089 14.7634 9.55614 15.4087C10.2014 16.0541 11.0763 16.4172 11.9889 16.4185C12.9016 16.4174 13.7766 16.0544 14.422 15.409C15.0674 14.7636 15.4305 13.8885 15.4315 12.9758C15.4301 12.0632 15.0668 11.1884 14.4213 10.5433C13.7758 9.89815 12.9008 9.53536 11.9882 9.53448V9.53381ZM11.9882 15.0798C11.4304 15.0798 10.8954 14.8582 10.5009 14.4638C10.1065 14.0693 9.88487 13.5343 9.88487 12.9765C9.88487 12.4186 10.1065 11.8837 10.5009 11.4892C10.8954 11.0947 11.4304 10.8731 11.9882 10.8731C12.546 10.8731 13.081 11.0947 13.4755 11.4892C13.8699 11.8837 14.0915 12.4186 14.0915 12.9765C14.0915 13.5343 13.8699 14.0693 13.4755 14.4638C13.081 14.8582 12.546 15.0798 11.9882 15.0798Z"
      fill="#C9E6E4"
    />
    <path
      d="M15.438 10.3843C15.8935 10.3843 16.2627 10.015 16.2627 9.55959C16.2627 9.10414 15.8935 8.73492 15.438 8.73492C14.9826 8.73492 14.6133 9.10414 14.6133 9.55959C14.6133 10.015 14.9826 10.3843 15.438 10.3843Z"
      fill="#C9E6E4"
    />
  </svg>
);

export const linkedin = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12.9879" r="12" />
    <path
      d="M8.6276 8.32094C8.62743 8.67456 8.48678 9.01363 8.23661 9.26355C7.98644 9.51348 7.64723 9.65378 7.2936 9.65361C6.93998 9.65343 6.60091 9.51278 6.35099 9.26261C6.10107 9.01244 5.96076 8.67323 5.96094 8.31961C5.96111 7.96598 6.10176 7.62691 6.35193 7.37699C6.60211 7.12707 6.94132 6.98676 7.29494 6.98694C7.64856 6.98712 7.98763 7.12776 8.23755 7.37793C8.48748 7.62811 8.62778 7.96732 8.6276 8.32094ZM8.6676 10.6409H6.00094V18.9876H8.6676V10.6409ZM12.8809 10.6409H10.2276V18.9876H12.8543V14.6076C12.8543 12.1676 16.0343 11.9409 16.0343 14.6076V18.9876H18.6676V13.7009C18.6676 9.58761 13.9609 9.74094 12.8543 11.7609L12.8809 10.6409Z"
      fill="#C9E6E4"
    />
  </svg>
);

export const bulletPoint = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 51.6 51.6"
    width="24"
    height="24"
  >
    <defs>
      <style>
        {`.cls-1 { fill: #e2e24f; }
          .cls-2 { fill: #1b5843; }`}
      </style>
    </defs>
    <circle className="cls-2" cx="25.8" cy="25.8" r="25.8" />
    <g id="arrow">
      <polygon
        className="cls-1"
        points="41.456 29.149 44.248 32.935 40.043 34.879 40.532 32.833 21.263 27.206 8.127 17.944 8.921 16.721 21.648 25.785 40.894 31.425 41.456 29.149"
      />
    </g>
  </svg>
);
